const includes = require('lodash/includes');
const get = require('lodash/get');
const noop = require('lodash/noop');

const inject = ['$uibModal', '$q', '$document'];

const legitDismissReasons = [
  'backdrop click',
  'escape key pressed',
  'corner x clicked'
];

function DialogService($uibModal, $q, $document) {
  this.supressModalCloseReject = function(err) {
    if (angular.isUndefined(err) || includes(legitDismissReasons, err)) {
      return false;
    }
    return $q.reject(err);
  };

  this.open = function(config = {}) {
    const modal = $uibModal.open({
      component: 'ogConfirmationDialog',
      resolve: angular.extend({
        templateUrl: () => config.templateUrl,
        confirmText: () => config.confirmText,
        cancelText: () => config.cancelText
      }, config.resolve),
      windowTopClass: config.windowTopClass,
      ariaLabelledBy: config.ariaLabelledBy,
      ariaDescribedBy: config.ariaDescribedBy
    });

    modal.rendered.then(() => $document[0].querySelector('.og-modal-window').setAttribute('aria-modal', true));

    modal.result = modal.result
      .then(get(config, 'onSuccess', noop))
      .catch(this.supressModalCloseReject);

    return modal;
  };
}

DialogService.$inject = inject;

module.exports = DialogService;
